(() => {
  'use strict';
  const root = document.body.dataset.root || '/';
  const currency = document.body.dataset.currency || 'USD';
  const engine = window.DrkConfiguration;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency, minimumFractionDigits: cents % 100 === 0 ? 0 : undefined
  }).format(cents / 100);
  const drawer = document.querySelector('.cart-drawer');
  let returnFocus, cartBusy = false;
  async function api(route, body) {
    const response = await fetch(root + route, {method: body ? 'POST' : 'GET',
      headers: body ? {'Content-Type': 'application/json', Accept: 'application/json'} : {Accept: 'application/json'},
      body: body ? JSON.stringify(body) : undefined});
    const result = await response.json();
    if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Unable to update your bag. Please try again.');
    return result;
  }
  async function refreshCart() {
    // Liquid renders bundle groups and component information; no duplicate pricing database.
    const response = await fetch(root + '?sections=cart-drawer', {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('Unable to load your bag. Please try again.');
    const sections = await response.json();
    if (!sections['cart-drawer']) throw new Error('Unable to load your bag. Please try again.');
    drawer.querySelector('.cart-contents').innerHTML = sections['cart-drawer'];
    const count = drawer.querySelector('[data-cart-count]').dataset.cartCount;
    document.querySelectorAll('[data-bag-count]').forEach(node => node.textContent = count);
  }
  function closeCart() {
    drawer.classList.remove('is-visible'); drawer.close();
    document.documentElement.classList.remove('cart-is-open');
    if (returnFocus?.isConnected) returnFocus.focus();
  }
  async function openCart() {
    if (!drawer.open) {returnFocus = document.activeElement; drawer.showModal();}
    document.documentElement.classList.add('cart-is-open'); drawer.classList.add('is-visible');
    const error = drawer.querySelector('.form-error'); error.textContent = '';
    try {await refreshCart();} catch (exception) {error.textContent = exception.message;}
  }
  document.querySelectorAll('[data-open-cart]').forEach(link => link.addEventListener('click', event => {event.preventDefault(); openCart();}));
  drawer.querySelector('.cart-close').addEventListener('click', closeCart);
  drawer.addEventListener('cancel', event => {event.preventDefault(); closeCart();});
  drawer.addEventListener('click', async event => {
    if (event.target === drawer) {const box = drawer.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeCart();}
    if (event.target.closest('[data-close-cart]')) closeCart();
    const control = event.target.closest('[data-key]');
    if (!control || cartBusy) return;
    cartBusy = true;
    drawer.querySelectorAll('[data-key],button[name=checkout]').forEach(button => button.disabled = true);
    const error = drawer.querySelector('.form-error'); error.textContent = '';
    try {await api('cart/change.js', {id: control.dataset.key, quantity: Number(control.dataset.quantity)}); await refreshCart(); drawer.querySelector('.cart-close').focus();}
    catch (exception) {error.textContent = exception.message; try {await refreshCart();} catch (_) {} }
    finally {cartBusy = false; drawer.querySelectorAll('[data-key],button[name=checkout]').forEach(button => button.disabled = false);}
  });
  function init(scope = document) {
    scope.querySelectorAll('[data-product-root]:not([data-ready])').forEach(host => {
      host.dataset.ready = 'true';
      let data;
      try {data = JSON.parse(host.querySelector('[data-product-data]').textContent);} catch (_) {return;}
      // Presentation cannot override Shopify prices, availability or launch gates.
      const presentation = data.presentation || {};
      ['cover','records','photos','cropStyles','nativeCropFinishes','customizationOptions','fixedSize'].forEach(key => {
        if (presentation[key] !== undefined) data[key] = presentation[key];
      });
      const resolvePhoto = photo => {
        if (!photo?.file) return photo;
        const stem = photo.file.replace(/\.[^.]+$/, '');
        const asset = (data.nativePhotos || []).find(value => value.file.startsWith(stem + '.') || value.file.startsWith(stem + '_'));
        return asset ? {...photo, id: asset.id, url: asset.url} : photo;
      };
      data.cover = resolvePhoto(data.cover);
      data.photos = (data.photos || []).map(resolvePhoto);
      data.records = (data.records || []).map(record => ({...record, photo: resolvePhoto(record.photo)}));
      const form = host.querySelector('[data-purchase-form]'), size = form.querySelector('[data-size]'), finish = form.querySelector('[data-finish]');
      if (finish?.tagName === 'SELECT' && data.customizationOptions?.length) {
        finish.replaceChildren(...data.customizationOptions.map(value => new Option(value, value)));
      }
      if (data.fixedSize && !size.options.length) size.add(new Option(data.fixedSize, data.fixedSize));
      const crop = form.querySelector('[data-crop]'), cropWrap = form.querySelector('[data-crop-wrap]');
      const id = form.querySelector('[data-selected-variant]'), add = form.querySelector('[data-add]');
      const quantity = form.elements.quantity, error = form.querySelector('[data-form-error]');
      const frame = host.querySelector('[data-photo-frame]'), image = frame?.querySelector('img');
      const copy = form.querySelector('[data-custom-copy]'), propertyContainer = form.querySelector('[data-production-properties]');
      const supported = data.supported && data.options.every(option => option.role !== 'unsupported') && size.options.length > 0;
      const isTank = data.id === 7291327741987;
      let fit = null, finishNote = null, fitNote = null;
      if (isTank) {
        const finishLabel = form.querySelector('label[for="' + finish.id + '"]');
        if (finishLabel) finishLabel.textContent = 'Finish';
        finish.value = 'Original';
        finishNote = document.createElement('div'); finishNote.className = 'customization-note';
        finishNote.append(document.createElement('p')); finish.after(finishNote);
        const fitLabel = document.createElement('label'); fitLabel.htmlFor = 'fit-' + form.getAttribute('id'); fitLabel.textContent = 'Fit';
        fit = document.createElement('select'); fit.id = fitLabel.htmlFor; fit.required = true;
        const fitIndex = data.options.findIndex(option => option.role === 'fit');
        const fitValues = [...new Set(data.variants.map(variant => variant.options[fitIndex]))].filter(Boolean);
        fit.append(...fitValues.map(value => new Option(value, value))); fit.value = 'Cropped';
        fitNote = document.createElement('div'); fitNote.className = 'customization-note'; fitNote.setAttribute('aria-live','polite'); fitNote.append(document.createElement('p'));
        finishNote.after(fitLabel); fitLabel.after(fit); fit.after(fitNote);
      }
      let busy = false, lastPhotoKey = null;
      const selection = () => ({size: size.value, finish: finish?.value || 'Original', cropStyle: crop?.value || '', fit: fit?.value || ''});
      function resetZoom() {frame?.classList.remove('is-zoomed'); frame?.setAttribute('aria-pressed', 'false'); image?.style.removeProperty('transform-origin');}
      function showPhoto(photo) {
        if (!image || !photo?.url) return;
        resetZoom(); image.removeAttribute('srcset'); image.src = photo.url.replace(/_800x800(?=\.)/, '_3200x3200').replace(/([?&])width=1600(?=&|$)/, '$1width=3200'); image.alt = photo.alt || '';
        image.style.objectPosition = photo.position || '50% 50%'; image.style.objectFit = photo.fit || 'cover';
        image.style.setProperty('--photo-scale', Number(photo.scale) || 1); image.style.setProperty('--photo-origin', photo.origin || '50% 50%');
        host.querySelectorAll('[data-photo-id]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.photoId === String(photo.id) || button.dataset.photoId === photo.file)));
      }
      function update(forcePhoto = false) {
        let chosen = selection();
        const base = engine.recordFor(data.records.filter(record => !record.cropStyle), chosen);
        const needsCrop = Boolean(base?.requiresCrop);
        if (crop) {cropWrap.hidden = !needsCrop; crop.disabled = !needsCrop; crop.required = needsCrop; if (!needsCrop) crop.value = ''; chosen = selection();}
        const record = engine.recordFor(data.records, chosen);
        const variant = engine.variantFor(data, chosen);
        const matching = data.variants.filter(value => engine.finishMatches(data, value, chosen.finish));
        const price = variant?.price ?? (matching.length ? Math.min(...matching.map(value => value.price)) : null);
        form.querySelector('[data-price]').textContent = price == null ? 'Unavailable' : money(price);
        const cardPrice = host.querySelector('[data-card-price]');
        if (cardPrice) {
          const cardPrices = data.variants.filter(value => value.available).map(value => value.price);
          const minimumPrice = cardPrices.length ? Math.min(...cardPrices) : null;
          cardPrice.textContent = minimumPrice == null ? 'Unavailable' : (new Set(cardPrices).size > 1 ? 'Starting at ' : '') + money(minimumPrice);
        }
        form.querySelector('[data-selection]').textContent = chosen.finish + (chosen.fit ? ' / ' + chosen.fit : '') + (chosen.cropStyle ? ' / ' + chosen.cropStyle : '');
        const description = chosen.finish === 'Original' ? '' : record?.description || '';
        copy.hidden = isTank || !description; copy.querySelector('p').textContent = description;
        if (isTank) {
          finishNote.querySelector('p').textContent = chosen.finish === 'Painted' ? 'Multicolor paint applied by hand.' : 'Standard finish. No added paint.';
          fitNote.querySelector('p').textContent = chosen.fit === 'Full Fit' ? 'Full Fit: Original full-length tank, left uncut. Full-length photos coming soon.' : 'Hand-cut raw hem for a cropped fit.';
        }
        // Require editable production mapping for every finish; fail closed until setup is complete.
        const configured = Boolean(base?.production) && (!needsCrop || (crop && data.cropStyles?.includes(chosen.cropStyle)));
        id.value = variant?.id || ''; id.disabled = !variant;
        propertyContainer.replaceChildren();
        const properties = engine.propertiesFor(record || base, chosen, data.baseProduct);
        for (const [name,value] of Object.entries(properties)) {
          if (!value || name === 'Crop Style') continue;
          const field = document.createElement('input'); field.type = 'hidden'; field.name = `properties[${name}]`; field.value = value; propertyContainer.append(field);
        }
        if (variant) {quantity.min = variant.quantityRule.min; quantity.step = variant.quantityRule.increment; quantity.max = variant.quantityRule.max ?? 99;}
        add.disabled = busy || !supported || !data.enabled || !variant?.available || !configured;
        add.childNodes[0].textContent = busy ? 'Adding… ' : !supported ? 'Unavailable ' : !data.enabled ? 'Coming Soon ' : variant && !variant.available ? 'Sold Out ' : 'Add to Bag ';
        const photoKey = [chosen.finish, chosen.size, chosen.cropStyle].join('|');
        if (forcePhoto || photoKey !== lastPhotoKey) {
          const override = record?.photo?.url ? record.photo : null;
          showPhoto(override || (variant?.image ? {...data.cover, url: variant.image} : data.cover)); lastPhotoKey = photoKey;
        }
        // Option labels show real Shopify prices for the selected size (or minimum for that finish).
        if (finish?.tagName === 'SELECT') [...finish.options].forEach(option => {
          const rows = data.variants.filter(value => engine.finishMatches(data, value, option.value) && data.options.every((definition,index) => definition.role !== 'size' || !chosen.size || value.options[index] === chosen.size));
          option.textContent = isTank ? option.value + (option.value === 'Painted' ? ' (+$16)' : '') : option.value + (rows.length ? ' — ' + money(Math.min(...rows.map(value => value.price))) : ' — Unavailable');
        });
      }
      host.querySelectorAll('[data-photo-id]').forEach(button => button.addEventListener('click', event => {
        event.preventDefault(); event.stopPropagation();
        showPhoto(data.photos.find(photo => String(photo.id) === button.dataset.photoId || photo.file === button.dataset.photoId) || {id:button.dataset.photoId,url:button.dataset.photo,alt:button.dataset.alt});
      }));
      function zoom(event) {
        if (host.matches('details') && !host.open) return;
        event.preventDefault(); event.stopPropagation();
        const zoomed = frame.classList.toggle('is-zoomed'); frame.setAttribute('aria-pressed', String(zoomed));
        const box = frame.getBoundingClientRect();
        if (zoomed && image) image.style.transformOrigin = event.detail ? `${Math.max(0,Math.min(100,(event.clientX-box.left)/box.width*100))}% ${Math.max(0,Math.min(100,(event.clientY-box.top)/box.height*100))}%` : '50% 50%';
        else image?.style.removeProperty('transform-origin');
      }
      frame?.addEventListener('click', zoom);
      frame?.addEventListener('keydown', event => {if (event.key === 'Enter' || event.key === ' ') zoom(event);});
      finish?.addEventListener('change', () => {if (data.id === 7291327709219 && finish.value === 'Crop' && crop) crop.value = 'Baby Crop';});
      form.addEventListener('change', () => update());
      form.addEventListener('submit', async event => {
        event.preventDefault(); error.textContent = '';
        if (busy || !form.reportValidity()) return;
        update(); if (add.disabled || !id.value) {error.textContent = 'Please choose an available size and customization.'; return;}
        busy = true; update();
        try {
          const chosen = selection(), record = engine.recordFor(data.records, chosen);
          const properties = engine.propertiesFor(record, chosen, data.baseProduct);
          const result = await api('cart/add.js', {items:[{id:Number(id.value),quantity:Number(quantity.value),properties}]});
          if (!result) throw new Error('Unable to add your piece. Please try again.');
          await openCart();
        } catch (exception) {error.textContent = exception.message;}
        finally {busy = false; update();}
      });
      if (host.matches('details')) host.addEventListener('toggle', () => {
        resetZoom();
        if (!host.open) {showPhoto(data.cover); return;}
        scope.querySelectorAll('.quick-product').forEach(other => {if (other !== host) other.open = false;});
        update(true);
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (!host.open) return;
          const header = document.querySelector('header');
          window.scrollTo({top:Math.max(0,host.closest('.minimal-card').getBoundingClientRect().top + window.scrollY - header.getBoundingClientRect().height - 24),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        }));
      });
      // Support real variant deep links on a product page.
      if (!host.matches('details')) {
        const requested = data.variants.find(variant => String(variant.id) === new URLSearchParams(location.search).get('variant'));
        if (requested) data.options.forEach((option,index) => {
          const value = requested.options[index], field = option.role === 'size' ? size : option.role === 'fit' ? fit : finish;
          if (option.role === 'finish' && data.nativeCropFinishes && /^(Natural|Baby) Crop/.test(value)) {
            if (finish) finish.value = value.includes('Distress') ? 'Crop + Distress' : 'Crop';
            if (crop) crop.value = value.startsWith('Baby') ? 'Baby Crop' : 'Natural Crop';
          } else if (field) field.value = value;
        });
      }
      update();
      // The initial main photo is the approved cover, independently of Original's selection image.
      if (host.matches('details') || !new URLSearchParams(location.search).has('variant')) showPhoto(data.cover);
    });
    scope.querySelectorAll('.info-panel:not([data-ready])').forEach(panel => {
      panel.dataset.ready = 'true'; panel.addEventListener('toggle', () => {if (panel.open) panel.parentElement.querySelectorAll('.info-panel').forEach(other => {if (other !== panel) other.open = false;});});
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  const logoLink = document.querySelector('.home-page header .theme-logo-link'), campaign = document.querySelector('[data-campaign]');
  if (logoLink && campaign) {
    const logo = logoLink.querySelector('img'), photo = campaign.querySelector('img'); let frame = 0;
    function scaleHeader() {
      frame = 0; const height = document.querySelector('header').getBoundingClientRect().height;
      const end = Math.max(1,campaign.getBoundingClientRect().bottom + window.scrollY - height);
      const progress = Math.min(1,Math.max(0,window.scrollY / end)), mobile = window.innerWidth <= 600;
      const ratio = logo.naturalWidth && logo.naturalHeight ? logo.naturalWidth / logo.naturalHeight : 5.28;
      const small = mobile ? 16 : 18, start = mobile ? Math.min(photo.clientWidth,photo.clientHeight * (photo.naturalWidth / photo.naturalHeight || 2/3)) : window.innerWidth * .6;
      logoLink.style.width = (start + (small*ratio - start)*progress) + 'px';
      logoLink.style.top = ((mobile?60:24) + ((height-small)/2-(mobile?60:24))*progress) + 'px';
    }
    const schedule = () => {if (!frame) frame = requestAnimationFrame(scaleHeader);};
    addEventListener('scroll', schedule, {passive:true}); addEventListener('resize', schedule); logo.addEventListener('load', schedule); photo.addEventListener('load', schedule); scaleHeader();
  }
})();
